export function formatVolume(value: number): string {
  if (value === 0) return '0'
  const sign = value < 0 ? '-' : ''
  const fixedValue = Math.abs(value).toFixed(3)
  const [integerPart, decimalPart = ''] = fixedValue.split('.')

  // Remove trailing zeros from decimal part
  const trimmedDecimalPart = decimalPart.replace(/0+$/, '')

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  const formatted = trimmedDecimalPart ? `${formattedInteger}.${trimmedDecimalPart}` : formattedInteger
  return `${sign}${formatted}`
}

export function formatVolumeVariance(value: number, isComparison = false): string {
  if (!isComparison) {
    return formatVolume(value)
  }

  if (value === 0) return '0'
  const sign = value > 0 ? '+' : '-'
  const fixedValue = Math.abs(value).toFixed(3)
  const [integerPart, decimalPart = ''] = fixedValue.split('.')

  // Remove trailing zeros from decimal part
  const trimmedDecimalPart = decimalPart.replace(/0+$/, '')

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const formatted = trimmedDecimalPart ? `${formattedInteger}.${trimmedDecimalPart}` : formattedInteger

  return `${sign}${formatted}`
}

export function formatVolumeConsistent(value: number, precision: number): string {
  if (value === 0) {
    return precision === 0 ? '0' : `0.${'0'.repeat(precision)}`
  }
  const sign = value < 0 ? '-' : ''
  const fixedValue = Math.abs(value).toFixed(precision)
  const [integerPart, decimalPart = ''] = fixedValue.split('.')

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  if (precision === 0) {
    return `${sign}${formattedInteger}`
  }

  return `${sign}${formattedInteger}.${decimalPart}`
}

export function formatVolumeVarianceConsistent(
  value: number,
  precision: number,
  isComparison = false
): string {
  if (!isComparison) {
    return formatVolumeConsistent(value, precision)
  }

  if (value === 0) {
    return precision === 0 ? '0' : `0.${'0'.repeat(precision)}`
  }
  const sign = value > 0 ? '+' : '-'
  const fixedValue = Math.abs(value).toFixed(precision)
  const [integerPart, decimalPart = ''] = fixedValue.split('.')

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  if (precision === 0) {
    return `${sign}${formattedInteger}`
  }

  return `${sign}${formattedInteger}.${decimalPart}`
}
